/**
 * Single Project Header Block JavaScript
 */

import { isBlockOnPage } from "../../src/js/modules/block-present.js";

(function ($) {
  "use strict";

  if (!isBlockOnPage("single-project-header")) {
    return;
  }

  function initSlickSlider() {
    const $slider = $(".variable-width");
    if (!$slider.length || typeof $slider.slick !== "function") {
      return;
    }

    $slider.slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true,
            arrows: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
            arrows: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }

  $(document).ready(function () {
    initSlickSlider();
  });
})(jQuery);
